import { CashbackSatsUtilizationType } from "types/enums";
import { ICashbackSatsUtilizationPreview } from "types/types";

export const UTILIZATION_TYPES = [
  CashbackSatsUtilizationType.CONVERSION_TO_CREDITS,
  CashbackSatsUtilizationType.DONATION_TO_STOSUJ,
  "LIGHTNING",
];

interface IProps {
  available: number;
  onClose: () => void;
  refresh: () => void;
}

interface UtilizationItemProps {
  type: typeof UTILIZATION_TYPES[number];
  value?: typeof UTILIZATION_TYPES[number];
  onClick: (value?: typeof UTILIZATION_TYPES[number]) => void;
  data?: ICashbackSatsUtilizationPreview;
  hasAvailableSats: boolean;
  onSubmit: () => Promise<void>;
  isSubmitting: boolean;
}

interface StatItemProps {
  label: string;
  value?: string | number;
  icon?: JSX.Element;
}

export default IProps;
export type { StatItemProps, UtilizationItemProps };